export class ContactInfo{
    name : string;
    emailId : string;
}